export class PropsDiff {
  // Compare two objects and returns the diff
  static diff(nextProps: object, prevProps: object | undefined): Array<string> {
    if (!prevProps) {
      return Object.keys(nextProps);
    }

    const keys = new Set(Object.keys(nextProps).concat(Object.keys(prevProps))).values();
    const ret: string[] = [];

    for (const key of keys) {
      if (prevProps[key] !== nextProps[key]) {
        ret.push(key);
      }
    }

    return ret;
  }
}
